export const carrierLogoPaths: { [key: string]: string } = {
  MetLife: '/metlife.png',
  LifeLock: '/lifelock.png',
  'Dental Select': '/dentalselect.png',
  Ameritas: '/ameritas.png'
}
